import { mapShoppingCartConfigurationBundlesToUpdate } from "../adapters/configuration.adapter";
import httpClient from "../config/httpClient";
import { ApartmentDto, ResolveApartmentDto } from "../models/coverage.model";
import { ShoppingCartConfigurationBundleDto, ShoppingCartConfigurationDto } from "../models/shoppingCart.model";

export abstract class ProductChangeOfAddressService {
	private static readonly BASE_URL = "sys03/customers/products/change-of-address-processes";
	private static readonly ADDRESSES_URL = this.BASE_URL.concat("/addresses");

	public static get(id: number) {
		return httpClient.get(`${this.BASE_URL}/${id}`);
	}

	public static delete(id: number) {
		return httpClient.delete(`${this.BASE_URL}/${id}`);
	}

	public static create(payload: any) {
		return httpClient.post(this.BASE_URL, payload);
	}

	public static update(id: number, payload: any) {
		return httpClient.patch(`${this.BASE_URL}/${id}`, payload);
	}

	public static getAddressesByZip({ zip }: { zip: string }): any {
		const url = `${this.ADDRESSES_URL}/zip/${zip}`;
		return httpClient.get(url);
	}

	public static getAddressesByCoordinates({ lng, lat }: { lng: string; lat: string }): any {
		const url = `${this.ADDRESSES_URL}/area`;
		return httpClient.get(url, {
			params: { lng, lat }
		});
	}

	public static getAddressById({ id }: { id: string }): any {
		const url = `${this.ADDRESSES_URL}/${id}`;
		return httpClient.get(url);
	}

	public static getApartmentById({ id }: { id: string }) {
		const url = `${this.ADDRESSES_URL}/apartments/${encodeURIComponent(id)}`;
		return httpClient.get<ApartmentDto>(url);
	}

	public static resolveApartmentById({ id }: { id: string }) {
		const url = `${this.ADDRESSES_URL}/apartments/resolve/${id}`;
		return httpClient.get<ResolveApartmentDto>(url);
	}

	public static getChangeOfAddressIntermediateSummary({ shoppingCartId }: { shoppingCartId: string }) {
		const url = `/${this.BASE_URL}/intermediate-shopping-carts/${shoppingCartId}/summary`;
		return httpClient.get(url);
	}

	public static getChangeOfAddressIntermediateConfiguration({ shoppingCartId }: { shoppingCartId: string }) {
		const url = `/${this.BASE_URL}/intermediate-shopping-carts/${shoppingCartId}/configuration`;
		return httpClient.get<ShoppingCartConfigurationDto>(url);
	}

	public static putChangeOfAddressIntermediateConfiguration({ id, bundles = [] }: { id: string; bundles: ShoppingCartConfigurationBundleDto[] }) {
		const url = `/${this.BASE_URL}/intermediate-shopping-carts/${id}/configuration`;
		const body = mapShoppingCartConfigurationBundlesToUpdate(bundles);

		return httpClient.put(url, body);
	}

	public static send(id: string) {
		const url = `/${this.BASE_URL}/${id}/send-intermediate`;
		return httpClient.put(url);
	}
}
